import Icon from "components/Icon/Icon";
import Link from "components/Link/Link";
import styled from "styled-components";
import { valueLabel } from "styles/typography";

// Centers the card in the content area. The Storage page Wrapper already
// reserves the right-panel width when the panel is open, so this only needs to
// center within whatever space is left.
export const CardCenterer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Card = styled.div`
  box-sizing: border-box;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 1040px;
  margin-top: 20px;
  padding: 24px;
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.divider};
  border-radius: 2px;
`;

// Two columns side by side keep the card wide and short; they stack when the
// card is too narrow to hold both.
export const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 28px;
`;

export const MainCol = styled.div`
  display: flex;
  flex: 1 1 300px;
  min-width: 0;
  flex-direction: column;
`;

// Grows to share the row when side by side, and fills the full width when the
// row wraps — so the address never sits narrow-and-left in a lopsided stack.
export const AsideCol = styled.div`
  flex: 1 1 340px;
  min-width: 0;
`;

export const Subtitle = styled.div`
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.black50};
`;

export const AddressBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 16px 20px;
  background: ${({ theme }) => theme.whiteSmoke};
  border-radius: 2px;
`;

export const AddressLabel = styled.div`
  ${valueLabel}
  margin-bottom: 10px;
  color: ${({ theme }) => theme.textMuted};
`;

export const AddressLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
`;

export const AddressText = styled.span`
  font-size: 15px;
  line-height: 1.4;
  color: ${({ theme }) => theme.accentText};
  word-break: break-word;
`;

export const SuitePill = styled.span`
  display: inline-block;
  padding: 2px 10px;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.primary};
  background: ${({ theme }) => theme.primaryPale};
  border-radius: 2px;
`;

export const CopyIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  background-color: ${({ theme }) => theme.black50};
  cursor: pointer;
`;

export const SuiteNote = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.black50};
`;

export const InfoBadge = styled.span`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-top: 1px;
  font-size: 11px;
  font-weight: 700;
  font-style: italic;
  line-height: 16px;
  text-align: center;
  color: ${({ theme }) => theme.black50};
  border: 1px solid ${({ theme }) => theme.black50};
  border-radius: 50%;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`;

export const WhatToShipLink = styled(Link)`
  font-weight: 600;
`;
